<span class="bg-{{status}}">{{text}}</span>
